"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSvgIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _logger = require("../../skybase-core/utils/logger");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _value = require("../../skybase-core/utils/value");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @namespace skybase-components.sb-icon
 *
 * @public
 *
 * @class
 * @classdesc
 * Main Icon component for SVG images, which draws given icon.
 *
 */
var SbSvgIcon = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbSvgIcon, _PureComponent);

  var _super = _createSuper(SbSvgIcon);

  function SbSvgIcon() {
    var _this;

    _classCallCheck(this, SbSvgIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassNames", function (props) {
      return (0, _classnames.default)('sb-svg-icon', props.className);
    });

    return _this;
  }

  _createClass(SbSvgIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // DEPRECATED MESSAGE - remove it in next major version.
      (0, _logger.deprecate)('SbSvgIcon component is deprecated and will be removed in next major version.');
    }
    /**
     * @desc
     * Returns calculated class names based on given criteria.
     *
     * @private
     * @function
     *
     * @param {object}  props - Properties passed to this component.
     */

  }, {
    key: "render",

    /**
     * @desc
     * Main render routine.
     *
     * @returns {React.Component} *   - Generated react component.
     */
    value: function render() {
      var _this$props = this.props,
          path = _this$props.path,
          color = _this$props.color,
          Element = _this$props.component,
          className = _this$props.className,
          intl = _this$props.intl,
          rest = _objectWithoutProperties(_this$props, ["path", "color", "component", "className", "intl"]);

      var classNames = this.getClassNames(this.props);

      if (Element) {
        // Component needs to have capitalized name, otherwise React will leave it as is with no render.
        return /*#__PURE__*/_react.default.createElement(Element, _extends({
          classNames: classNames,
          color: color
        }, rest));
      }

      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg"
      }, rest, {
        className: classNames
      }), /*#__PURE__*/_react.default.createElement("path", {
        fill: color,
        d: path
      }));
    }
  }]);

  return SbSvgIcon;
}(_react.PureComponent);

exports.SbSvgIcon = SbSvgIcon;
SbSvgIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  path: function path(props, propName, componentName) {
    var path = props.path,
        component = props.component;

    if ((0, _value.isNullOrUndefined)(path) && (0, _value.isNullOrUndefined)(component)) {
      return new Error("One of props 'path' or 'component' was not specified in '".concat(componentName, "'."));
    }

    if (path) {
      var pathType = _typeof(path);

      return pathType !== 'string' ? new Error("Invalid prop of type '".concat(pathType, "', expected a 'string'.")) : null;
    }

    return null;
  }
};
SbSvgIcon.defaultProps = {
  className: '',
  color: '',
  path: ''
};
//# sourceMappingURL=sb-svg-icon.js.map